import { Layout } from 'antd';
import {
  GlobalOutlined,
  SendOutlined,
  TwitterOutlined,
  YoutubeOutlined,
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
} from '@ant-design/icons';
import { FACEBOOK_URL, INSTAGRAM_URL, LINKEDIN_URL, OFFICIAL_WEBSITE_URL, TELEGRAM_URL, TWITTER_URL, YOUTUBE_URL } from '@/constants/socialmediaConstants';

const { Footer } = Layout;

const AppFooter = ({ isLoggedIn }) => {
  const handleLinkClick = (url) => {
    window.open(url, '_blank');
  };
  return (
    <div className="flex flex-col">
      <Footer
        className="fixed bottom-0 w-full px-4 py-2 text-center md:flex md:justify-between md:text-left md:px-8"
        style={{ backgroundColor: '#253271', color: 'white' }} // Set the background color and text color
      >
        {!isLoggedIn && (
          <div className="flex items-center justify-center md:w-1/2">
            <GlobalOutlined
              onClick={() => handleLinkClick(OFFICIAL_WEBSITE_URL)}
              className="text-xl cursor-pointer mx-4"
              style={{ color: '#007BFF' }} // Retain individual icon colors if needed
            />
            <SendOutlined
              onClick={() => handleLinkClick(TELEGRAM_URL)}
              className="text-xl cursor-pointer mx-4"
              style={{ color: '#2CA5E0' }}
            />
            <TwitterOutlined
              onClick={() => handleLinkClick(TWITTER_URL)}
              className="text-xl cursor-pointer mx-4"
              style={{ color: '#1D9BF0' }}
            />
            <YoutubeOutlined
              onClick={() => handleLinkClick(YOUTUBE_URL)}
              className="text-xl cursor-pointer mx-4"
              style={{ color: '#FF0000' }}
            />
            <FacebookOutlined
              onClick={() => handleLinkClick(FACEBOOK_URL)}
              className="text-xl cursor-pointer mx-4"
              style={{ color: '#3B5998' }}
            />
            <InstagramOutlined
              onClick={() => handleLinkClick(INSTAGRAM_URL)}
              className="text-xl cursor-pointer mx-4"
              style={{ color: '#E1306C' }}
            />
            <LinkedinOutlined
              onClick={() => handleLinkClick(LINKEDIN_URL)}
              className="text-xl cursor-pointer mx-4"
              style={{ color: '#0077B5' }}
            />
          </div>
        )}

        <div className="border-l border-gray-400 pl-4 mt-4 md:mt-0 flex items-center">
          <span className="text-sm" style={{ color: 'white', marginRight: '0.5rem' }}>
            © {new Date().getFullYear()} Dashen Bank S.C. | © All Rights Reserved.
          </span>
          <span className="text-sm" style={{ color: 'white' }}>
          StMS - Developed by IT Modernization Program Management
          </span>
        </div>
      </Footer>
    </div>
  );
};

export default AppFooter;
